var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.98 35.96C28.8055 35.96 35.96 28.8055 35.96 19.98C35.96 11.1545 28.8055 4 19.98 4C11.1545 4 4 11.1545 4 19.98C4 28.8055 11.1545 35.96 19.98 35.96Z",
    fill: "url(#paint0_linear_150_32998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9399 31.9799C43.9399 38.5799 38.5799 43.9399 31.9799 43.9399C27.8999 43.9399 24.3199 41.8999 22.1599 38.7999C30.8799 37.8199 37.8199 30.8799 38.7999 22.1599C41.8999 24.3199 43.9399 27.8999 43.9399 31.9799Z",
    fill: "url(#paint1_linear_150_32998)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 19.4201L18.1 17.7401C17.62 17.5801 17.52 17.5401 17.52 16.8401C17.52 16.3201 17.88 15.9001 18.34 15.9001H21.34C21.98 15.9001 22.5 16.4801 22.5 17.2001C22.5 18.0201 23.18 18.7001 24 18.7001C24.82 18.7001 25.5 18.0201 25.5 17.2001C25.5 14.9001 23.72 13.0201 21.5 12.9201V12.8201C21.5 12.0001 20.82 11.3201 20 11.3201C19.18 11.3201 18.5 11.9801 18.5 12.8201V12.9201H18.32C16.22 12.9201 14.5 14.6801 14.5 16.8601C14.5 18.7601 15.34 19.9801 17.08 20.5801L21.9 22.2601C22.38 22.4201 22.48 22.4601 22.48 23.1601C22.48 23.6801 22.12 24.1001 21.66 24.1001H18.66C18.02 24.1001 17.5 23.5201 17.5 22.8001C17.5 21.9801 16.82 21.3001 16 21.3001C15.18 21.3001 14.5 21.9801 14.5 22.8001C14.5 25.1001 16.28 26.9801 18.5 27.0801V27.2001C18.5 28.0201 19.18 28.7001 20 28.7001C20.82 28.7001 21.5 28.0201 21.5 27.2001V27.1001H21.68C23.78 27.1001 25.5 25.3401 25.5 23.1601C25.5 21.2601 24.64 20.0401 22.9 19.4201Z",
    fill: "url(#paint2_linear_150_32998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32998",
    x1: -16.7221,
    y1: 41.743,
    x2: 47.4922,
    y2: -16.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32998",
    x1: 8.03831,
    y1: 47.8809,
    x2: 51.7988,
    y2: 8.06673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_32998",
    x1: 7.36788,
    y1: 31.8449,
    x2: 37.7047,
    y2: 14.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.4fe30c4ca223e5e1d9f76ce2e11399d6.svg";
export { ForwardRef as ReactComponent };